export enum FilterGroup {
  customerValueAnalysis = "customerValueAnalysis",
  nextBestActivity = "nextBestActivity",
  customerInformation = "customerInformation",
  customerContactChannels = "customerContactChannels",
  electricity = "electricity",
  gas = "gas",
  heating = "heating",
  glassFiber = "glassFiber",
  housingSituations = "housingSituations",
}

const CLVPreselections = [
  {
    label: "niedrig (0 bis 3)",
    value: { min: 0, max: 3 },
  },
  {
    label: "mittel (4 bis 7)",
    value: { min: 4, max: 7 },
  },
  {
    label: "hoch (8 bis 10)",
    value: { min: 8, max: 10 },
  },
];

const churnScorePreselections = [
  {
    label: "niedrig (1 bis 3)",
    value: { min: 1, max: 3 },
  },
  {
    label: "mittel (4 bis 7)",
    value: { min: 4, max: 7 },
  },
  {
    label: "hoch (8 bis 10)",
    value: { min: 8, max: 10 },
  },
];

const churnDeltaPreselections = [
  {
    label: "starke Abnahme (-9 bis -7)",
    value: { min: -9, max: -7 },
  },
  {
    label: "mittlere Abnahme (-6 bis -4)",
    value: { min: -6, max: -4 },
  },
  {
    label: "leichte Abnahme (-3 bis -1)",
    value: { min: -3, max: -1 },
  },
  {
    label: "unverändert (0)",
    value: { min: 0, max: 0 },
  },
  {
    label: "leichte Zunahme (1 bis 3)",
    value: { min: 1, max: 3 },
  },
  {
    label: "mittlere Zunahme (4 bis 6)",
    value: { min: 4, max: 6 },
  },
  {
    label: "starke Zunahme (7 bis 9)",
    value: { min: 7, max: 9 },
  },
];

export const preselections = {
  clv: CLVPreselections,
  churnScore: churnScorePreselections,
  churnDelta: churnDeltaPreselections,
};



// WEBPACK FOOTER //
// ./src/components/Filters/constants.tsx